<template>
  <PageArticleDetail
    :article="article"
    :header-configuration="headerConfiguration"
    :latest-articles="latestArticles ? latestArticles.entities : []"
    :menu-item="menuItem"/>
</template>

<script>
import { get } from 'lodash'
import AppRouteMixin from '~/mixins/AppRouteMixin'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import PageArticleDetail from '@theme/components/content/PageArticleDetail'

const PAGE = {
  name: 'RouteArticleDetail',
  nuxtI18n: {
    paths: {
      cs: '/clanek/:slug',
      de: '/artikel/:slug',
      en: '/article/:slug',
      sk: '/clanok/:slug',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageArticleDetail,
  },
  mixins: [AppRouteMixin, ImageUrlMixin],
  async asyncData({ app, store, params, error, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }
    const article = store.dispatch('article/LOAD_ARTICLE', {
      slug: params.slug,
      checkPermissions: true,
    })
    const latestArticles =
      app.$themeSettings.components.PageArticleDetail.latestArticles.count > 0
        ? store.dispatch('article/LOAD_ARTICLES', {
            page: 0,
            perPage: app.$themeSettings.components.PageArticleDetail.latestArticles.count,
          })
        : null
    const response = await Promise.allValues({
      article,
      latestArticles,
    })
    await store.dispatch('menu/FETCH_MENU', 'article')
    await store.dispatch('article/FETCH_CATEGORIES')
    await store.dispatch('article/FETCH_TAGS')
    const articlePerSite = get(response, 'article.site_enabled', false)
    if (
      !response.article ||
      (articlePerSite && articlePerSite.length && !articlePerSite.includes(app.$env.ACTIVE_THEME))
    ) {
      return app.$pageNotFound({ slug: params.slug })
    }
    if (response.article.error) {
      return error({ statusCode: response.article.error.statusCode })
    }
    store.commit('locale/SET_CANONICALS', {
      canonicalSlugs: get(response, 'article.page_meta.canonical_slugs', []),
    })
    return {
      ...response,
      headerConfiguration: await store.dispatch('article/LOAD_HEADER_CONFIGURATION'),
      menuItem: await store
        .dispatch('menu/FIND_MENU_ITEMS', {
          ids: response.article.article_category_reference
            ? response.article.article_category_reference.map(category => category.entity._id)
            : [],
          menu: 'article',
        })
        .then(items => items[0]),
    }
  },
}
export default PAGE
</script>
